module.exports = __webpack_public_path__ + "img/server.937a7fe1.svg";